'use client'
import styled from 'styled-components'

export const DivAddToCartWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 4px;
  justify-content: center;
  width: fit-content;
`
